import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toast: React.FC = () => {
  return <ToastContainer autoClose={7000} newestOnTop pauseOnFocusLoss />;
};

export default React.memo(Toast);
